// extracted by mini-css-extract-plugin
export default {"main0":"BaseSimplePage_main0__4BWxE","mainRow":"BaseSimplePage_mainRow__VkDoy","browserArea":"BaseSimplePage_browserArea__xZH+U","editorArea":"BaseSimplePage_editorArea__3dg0p"};